export type MarkerIconType =
    | 'pin'
    | 'radar'
    | 'dot'
    | 'location-dot'
    | 'check'
    | 'port'
    | 'place'
    | 'warehouse'
    | 'flag'
    | 'anchor'
    | 'anchor-check'
    | 'ship'
    | 'plane'
    | 'truck'
    | 'train'
    | 'plane-departure'
    | 'plane-arrival'
    | 'box-taped'
    | 'box-open'
    | 'water'
    | 'cloud'
    | 'road'
    | 'train-track';

export const TRANSPORT_ICONS: MarkerIconType[] = [
    'ship',
    'plane',
    'truck',
    'train',
];
export const LEG_ICONS: MarkerIconType[] = [
    'water',
    'cloud',
    'road',
    'train-track',
];
export const LOCATION_ICONS: MarkerIconType[] = [
    'warehouse',
    'flag',
    'anchor',
    'anchor-check',
];
export const LEGACY_ICONS: MarkerIconType[] = [
    'pin',
    'radar',
    'dot',
    'check',
    'port',
    'place',
];
